import React from 'react';
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer 
} from 'recharts';

const BarChartStatic = ({ 
  data, 
  dataKey = "value",    // La clé pour les valeurs (ex: "amount", "count")
  xKey = "name",        // La clé pour l'axe X (ex: "date", "status")
  color = "#5d55e8",    // Couleur de la barre
  barSize = 35,         // Largeur des barres
  showGrid = true       // Afficher ou non la grille
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
        {showGrid && (
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
        )}
        
        <XAxis 
          dataKey={xKey} 
          fontSize={10} 
          fontWeight={700}
          tickLine={false} 
          axisLine={false} 
          tick={{ fill: '#94a3b8' }}
          dy={10}
        />
        
        <YAxis 
          fontSize={10} 
          fontWeight={700}
          tickLine={false} 
          axisLine={false} 
          tick={{ fill: '#94a3b8' }}
        />
        
        <Tooltip 
          cursor={{ fill: '#f8fafc' }} 
          contentStyle={{ 
            borderRadius: '12px', 
            border: 'none', 
            boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
            fontSize: '12px',
            fontWeight: 'bold'
          }}
        />
        
        <Bar 
          dataKey={dataKey} 
          fill={color} 
          radius={[6, 6, 0, 0]} 
          barSize={barSize} 
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartStatic;